import { getNotificationsAsyncAction, markViewedNotificationsAsyncAction, } from "./Sagas";
import Slice from "./Slice";
export * from "./types";
export const { hideNotificationsErrorAction, hideErrorMarkViewedAction, setNotificationStateAction, resetRequesNotificationsStatus, } = Slice.actions;
export { getNotificationsAsyncAction, markViewedNotificationsAsyncAction };
